import React from "react";

const NoData = () => (<p>Awaiting test result data.</p>);

export default NoData;
